// AddManualPassageRequest.
//
// Class representing a request to add a manual passage at a specific pipeline section marker.
export class AddManualPassageRequest {
  public pipelineSectionMarkerId: number;
  public passageTimeStamp: Date;

  public constructor(pipelineSectionMarkerId: number, passageTimeStamp: Date) {
    this.pipelineSectionMarkerId = pipelineSectionMarkerId;
    this.passageTimeStamp = passageTimeStamp;
  }
}
